import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../../store';
import { videoAdapterSelectors, videoBarsAdapterSelectors } from './content.reducer';

export const selectContentState = (state: RootState) => state.content;

export const selectVideos = createSelector(selectContentState, (state) => state.videos.value);

export const selectVideoEntities = createSelector(selectVideos, (videos) =>
  videos ? videoAdapterSelectors.selectEntities(videos) : {}
);

export const selectAllVideos = createSelector(selectVideos, (videos) =>
  videos ? videoAdapterSelectors.selectAll(videos) : []
);

export const selectVideoById = createSelector(
  [selectVideoEntities, (_state: RootState, id: string) => id],
  (entities, id) => entities[id]
);
export const selectVideosLoading = createSelector(
  selectContentState,
  (state) => state.videos.loading
);
export const selectVideosLoaded = createSelector(
  selectContentState,
  (state) => state.videos.loaded
);
export const selectVideosError = createSelector(selectContentState, (state) => state.videos.error);

export const selectVideoBars = createSelector(selectContentState, (state) => state.videoBars.value);
export const selectVideoBarEntities = createSelector(selectVideoBars, (videoBars) =>
  videoBars ? videoBarsAdapterSelectors.selectEntities(videoBars) : []
);
export const selectAllVideoBars = createSelector(selectVideoBars, (videoBars) =>
  videoBars ? videoBarsAdapterSelectors.selectAll(videoBars) : []
);
export const selectVideoBarById = (id: string) =>
  createSelector(selectVideoBarEntities, (entities) => entities[id]);
export const selectVideoBarsLoading = createSelector(
  selectContentState,
  (state) => state.videoBars.loading
);
export const selectVideoBarsLoaded = createSelector(
  selectContentState,
  (state) => state.videoBars.loaded
);
export const selectVideoBarsError = createSelector(
  selectContentState,
  (state) => state.videoBars.error
);

export const selectProductAccessLoading = createSelector(
  selectContentState,
  (state) => state.productAccess.loading
);
export const selectProductAccessLoaded = createSelector(
  selectContentState,
  (state) => state.productAccess.loaded
);
export const selectProductAccessError = createSelector(
  selectContentState,
  (state) => state.productAccess.error
);
export const selectProductAccess = createSelector(
  selectContentState,
  (state) => state.productAccess.value!
);

export const selectNeedAccessLoading = createSelector(
  selectContentState,
  (state) => state.needAccess.loading
);
export const selectNeedAccessLoaded = createSelector(
  selectContentState,
  (state) => state.needAccess.loaded
);
export const selectNeedAccessError = createSelector(
  selectContentState,
  (state) => state.needAccess.error
);
export const selectNeedAccess = createSelector(
  selectContentState,
  (state) => state.needAccess.value!
);

export const selectPromotedProductsLoading = createSelector(
  selectContentState,
  (state) => state.promotedProducts.loading
);
export const selectPromotedProductsLoaded = createSelector(
  selectContentState,
  (state) => state.promotedProducts.loaded
);
export const selectPromotedProductsError = createSelector(
  selectContentState,
  (state) => state.promotedProducts.error
);
export const selectPromotedProducts = createSelector(
  selectContentState,
  (state) => state.promotedProducts.value!
);

export const selectCollectiblesLoading = createSelector(
  selectContentState,
  (state) => state.collectibles.loading
);
export const selectCollectiblesLoaded = createSelector(
  selectContentState,
  (state) => state.collectibles.loaded
);
export const selectCollectiblesError = createSelector(
  selectContentState,
  (state) => state.collectibles.error
);
export const selectCollectibles = createSelector(
  selectContentState,
  (state) => state.collectibles.value!
);

export const selectAddingToCart = createSelector(
  selectContentState,
  (state) => state.addingToCart.loading
);
export const selectAddedToCart = createSelector(
  selectContentState,
  (state) => state.addingToCart.loaded
);
export const selectBuyingNow = createSelector(
  selectContentState,
  (state) => state.buyItNow.loading
);
export const selectBuyNowResult = createSelector(
  selectContentState,
  (state) => state.buyItNow.loaded
);
